import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { NumberInputWUT } from "../../inputs/number-input-wut/number-input-wut.js";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { Widget } from "../widget/widget.js";
const NumberInputFieldWUT = ({
  id,
  target,
  value,
  validation,
  required,
  label,
  hideLabel,
  disabled,
  readOnly,
  placeholder,
  onChange,
  onBlur,
  description,
  onFocus,
  error,
  hasError = false,
  errorMessage,
  media,
  mediaSettings,
  FieldLayout,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          htmlFor: inputId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement,
          media,
          mediaSettings
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        NumberInputWUT,
        {
          value,
          validation,
          required,
          label,
          disabled,
          readOnly,
          placeholder,
          onChange,
          onBlur,
          onFocus,
          hasError,
          inputId,
          ariaDescribedBy,
          fieldId: id
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  NumberInputFieldWUT
};
//# sourceMappingURL=number-input-field-wut.js.map
